(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-featured-products]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const grid = section.querySelector('[data-featured-grid]');
      const heading = section.querySelector('[data-featured-heading]');
      const status = section.querySelector('[data-featured-status]');
      const retry = section.querySelector('[data-featured-retry]');
      const load = async () => {
        retry.hidden = true;
        status.textContent = 'Loading best sellers…';
        section.setAttribute('aria-busy', 'true');
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 12000);
        try {
          const url = new URL(section.dataset.collectionUrl, location.origin);
          if (url.origin !== location.origin) throw new Error('Invalid collection');
          const previewThemeId = new URL(location.href).searchParams.get('preview_theme_id');
          if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
          url.searchParams.set('sort_by', 'best-selling');
          url.searchParams.set('section_id', 'truck-featured-products');
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Products unavailable');
          const fragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const cards = [...fragment.querySelectorAll('[data-featured-products-fragment] .product-card')];
          if (!cards.length) throw new Error('No products');
          const limit = Math.min(12, Math.max(4, Number(section.dataset.limit) || 4));
          grid.replaceChildren(...cards.slice(0, limit));
          heading.textContent = section.dataset.heading || 'Best sellers';
          status.textContent = '';
        } catch {
          status.textContent = 'Showing catalogue products. Best sellers could not be loaded.';
          retry.hidden = false;
        } finally {
          clearTimeout(timer);
          section.removeAttribute('aria-busy');
        }
      };
      retry.addEventListener('click', load);
      load();
    });
  };
  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
